export default __webpack_public_path__ + "static/media/thumbnail_blog_22.e4b2eaa6.png";